export var DEPLOY_DATE = new Date('2026-10-06T05:37:15+0000');
